<template>
  <div class="banner-wrp banner-vertical">
    <div class="row">

      <div class="col-xs-12 col-md-12 banner">
        <a href="javascript:;">
        <div class="banner__item">
          <div class="banner__item-slogan">
            <h3 class="banner__item-title">Kayıt gününe özel</h3>
            <p class="banner__item-price">% 25 İNDİRİM</p>
          </div>
          <div class="row">
            <div class="col-md-12 banner__item-right">
              <div class="banner__item-right-image">
                <div class="banner__logo">
                  <img class="banner__logo-img" src="@/assets/img/yurt-logo-1.png" alt="">
                </div>
                <img class="banner__item-right--img" src="https://www.holywoodskyline.com/Images/movies.jpg" alt="">
              </div>
              <div class="banner__item-light"></div>
              <div class="banner__item-light light2"></div>
            </div>
          </div>
        </div>
        </a>
      </div>

      <div class="col-xs-12 col-md-12 banner">
        <a href="javascript:;">
        <div class="banner__item orange">
          <div class="banner__item-slogan">
            <h3 class="banner__item-title">Sevdiklerinizi düşünüyoruz</h3>
            <p class="banner__item-price">7/24 GÜVENLİK</p>
          </div>
          <div class="row">
            <div class="col-md-12 banner__item-right">
              <div class="banner__item-right-image">
                <div class="banner__logo">
                  <img class="banner__logo-img" src="@/assets/img/yurt-logo-1.png" alt="">
                </div>
                <img class="banner__item-right--img" src="@/assets/img/banner2.jpg" alt="">
              </div>
              <div class="banner__item-light orange"></div>
              <div class="banner__item-light orange orange2"></div>
            </div>
          </div>
        </div>
        </a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'AdvertBanner',
    props: {
    dorms: Array,
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/components/advert-banner";
</style>
